export default time => {
  const now = new Date();
  const timeAsDate = new Date(time);

  if (timeAsDate > now) {
    return now;
  }

  return time;
};
